"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getHeaders = function (xApiKey) {
    return {
        'X-Api-Key': xApiKey,
    };
};
exports.default = getHeaders;
